export default "__VITE_ASSET__zC1CBz4z__"